<template>

    <div class="swiper-container" id="ExtensionsSlider">

        <div class="swiper-wrapper">
            <slot></slot>
        </div>

        <div class="control">
            <div>
                <div class="button-prev btn-prev">précédent</div>
                <div></div>
                <div class="button-next btn-next">suivant</div>
            </div>
        </div>

    </div>

</template>

<script>
    import $ from 'jquery';
    import Swiper from 'swiper';

    export default {
        props: {},
        data() {
            return {
                swiperExtensions: null,
                numbreOfSlide: 0
            };
        },
        computed: {},
        methods: {
            initSwiper() {

                // Init
                this.swiperExtensions = new Swiper('#ExtensionsSlider', {
                    effect: "fade",
                    autoHeight: true,
                    threshold: 40,
                    speed: 300,
                    virtualTranslate: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '#ExtensionsSlider .button-next',
                        prevEl: '#ExtensionsSlider .button-prev',
                    }
                });

                this.numbreOfSlide = $('#ExtensionsSlider .swiper-slide').length

                this.swiperExtensions.on('slideChangeTransitionEnd', () => {


                    this.clearPagination();
                });

                this.clearPagination();


            },
            clearPagination() {

                // Efface le bouton Suivant en fin de course
                if (this.swiperExtensions.activeIndex === (this.numbreOfSlide - 1)) {
                    $('#ExtensionsSlider .button-next').addClass('disabled')
                } else {
                    $('#ExtensionsSlider .button-next').removeClass('disabled')
                }

                // Efface le bouton Précedent en début de course
                if (this.swiperExtensions.activeIndex === 0) {
                    $('#ExtensionsSlider .button-prev').addClass('disabled')
                } else {
                    $('#ExtensionsSlider .button-prev').removeClass('disabled')
                }

            },

        },
        mounted() {
            this.initSwiper();

        },
        created() {

        },
        destroyed() {

        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/cruise-product/ExtensionsSlider.vue